import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Gallery from "@/components/Gallery";
import { Reveal, Overline } from "@/components/motion";
import { getGallery } from "@/lib/api";
import { IMAGES } from "@/data/demo";

const StagePro = () => {
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    getGallery("stage_pro").then(setGallery);
  }, []);

  return (
    <div data-testid="stage-pro-page">
      <PageHero
        testId="stage-pro-hero"
        contentKey="stagepro"
        image={IMAGES.matchAction}
        overline="Haut niveau — encadrement professionnel"
        titleLines={[
          <span key="a" className="text-white">STAGE PRO</span>,
          <span key="b" className="text-gold">SEMI-PRO</span>,
        ]}
        subtitle="Une immersion dans le quotidien du football professionnel : préparation athlétique, analyse vidéo, oppositions de haut niveau et encadrement par des professionnels du jeu."
      >
        <Link
          to="/contact?objet=Stage%20Pro%20%2F%20Semi-Pro"
          data-testid="stage-pro-cta-contact"
          className="px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_20px_rgba(230,0,0,0.3)] inline-flex items-center gap-3"
        >
          Nous contacter <ArrowRight size={16} />
        </Link>
      </PageHero>

      {/* PRESENTATION */}
      <section data-testid="stage-pro-presentation" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-5">
            <Overline>La philosophie</Overline>
            <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl leading-[0.9] tracking-tight">
              Vivre le football <span className="text-gold">comme un pro</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <p className="text-white/70 leading-relaxed text-base md:text-lg">
              Le Stage Pro / Semi-Pro de 3M Match Pro s'adresse aux joueuses et joueurs confirmés qui
              veulent goûter aux méthodes du football professionnel. Programme individualisé, rythme
              d'entraînement intensif, récupération encadrée : tout est pensé pour reproduire une
              semaine de centre de formation.
            </p>
          </Reveal>
        </div>
      </section>

      <div className="bg-[#0a0a0a] border-y border-white/5">
        <Gallery items={gallery} title="En immersion" overline="Galerie photos & vidéos" testId="gallery-stage-pro" />
      </div>

      {/* CTA */}
      <section data-testid="stage-pro-cta" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
        <Reveal>
          <div className="relative border border-gold/25 p-10 md:p-16 overflow-hidden">
            <div
              className="absolute inset-0"
              style={{ background: "radial-gradient(ellipse 50% 60% at 80% 20%, rgba(212,175,55,0.1), transparent)" }}
            />
            <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
              <div>
                <h2 className="font-display uppercase text-4xl sm:text-5xl leading-[0.9] tracking-tight">
                  Prêt à passer <span className="text-gold">un cap</span> ?
                </h2>
                <p className="mt-3 text-white/60 max-w-md">
                  Parlez-nous de votre profil et de vos objectifs : nous construisons la session adaptée.
                </p>
              </div>
              <Link
                to="/contact?objet=Stage%20Pro%20%2F%20Semi-Pro"
                data-testid="stage-pro-cta-bottom"
                className="shrink-0 px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_20px_rgba(230,0,0,0.3)] inline-flex items-center gap-3"
              >
                Demander des informations <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default StagePro;
